import { render, staticRenderFns } from "./DependentModal.vue?vue&type=template&id=b406160a"
import script from "./DependentModal.vue?vue&type=script&lang=js"
export * from "./DependentModal.vue?vue&type=script&lang=js"
import style0 from "./DependentModal.vue?vue&type=style&index=0&id=b406160a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports